module.exports = __webpack_public_path__ + "img/54_49.9717597b.png";